import {
  FieldOkConfig,
  FieldOkListViewComponent,
  FieldOkMultiselectListViewComponent,
  QueryFieldOkListViewComponent,
} from '@softline/dynamic';
import { ZahlstamListView } from './list-view/zahlstam.list-view';

export const zahlstamFieldOk: FieldOkConfig = {
  name: 'zahlstam',
  type: 'default',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{zahlstam}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ZahlstamListView,
        sort: {
          properties: [{ property: 'zahlstam', title: 'Code' }],
        },
      },
    },
  ],
};

export const zahlstamMultiselectFieldOk: FieldOkConfig = {
  name: 'zahlstam',
  type: 'multi',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{zahlstam}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: FieldOkMultiselectListViewComponent,
      title: 'Auswahl',
      config: {
        component: ZahlstamListView,
        sort: {
          properties: [{ property: 'zahlstam', title: 'Code' }],
        },
      },
    },
  ],
};

export const zahlstamQueryFieldOk: FieldOkConfig = {
  name: 'zahlstam',
  type: 'query',
  priority: 0,
  defaultView: 'list',
  defaultDataView: 'list',
  template: '{{zahlstam}} - {{bezeichnung}}',
  autoQuery: true,
  views: [
    {
      name: 'list',
      component: QueryFieldOkListViewComponent,
      title: 'Auswahl',
      config: {
        component: ZahlstamListView,
        sort: {
          properties: [{ property: 'zahlstam', title: 'Code' }],
        },
      },
    },
  ],
};
